import React, { useState } from "react";
import { FiMenu } from "react-icons/fi";
import { AiFillHome, AiFillSignal } from "react-icons/ai";
import { BiUserPlus } from "react-icons/bi";
import { IoNotificationsCircleSharp } from "react-icons/io5";
import { Link } from "react-router-dom";
import "./Menu.css";

const Menu = () => {
	const [isMenuOpen, setIsMenuOpen] = useState(false);

	const toggleMenu = () => {
		setIsMenuOpen(!isMenuOpen);
	};

	return (
		<div>
			<button className='menu-icon2-lealtad' onClick={toggleMenu}>
				<FiMenu />
			</button>

			{isMenuOpen && (
				<div className='menu-options2-lealtad'>
					<Link style={{ textDecoration: "none" }} to='/inicio-lealtad'>
						<div className='button-index-left2-lealtad'>
							<AiFillHome className='icon-button-left2-lealtad' />
							<p className='text-button-left-in2-lealtad'>Home</p>
						</div>
					</Link>

					<Link style={{ textDecoration: "none" }} to='/lealtad/informe'>
						<div className='button-index-left2-lealtad'>
							<AiFillSignal className='icon-button-left2-lealtad' />
							<p className='text-button-left-in2-lealtad'>Informe</p>
						</div>
					</Link>

					<Link style={{ textDecoration: "none" }} to='/lealtad/detailMDR'>
						<div className='button-index-left2-lealtad'>
							<AiFillSignal className='icon-button-left2-lealtad' />
							<p className='text-button-left2-lealtad'>Matriz de Riesgo</p>
						</div>
					</Link>

					<Link
						style={{ textDecoration: "none" }}
						to='/lealtad/crear_usuaruis'
					>
						<div className='button-index-left2-lealtad'>
							<BiUserPlus className='icon-button-left2-lealtad' />
							<p className='text-button-left2-lealtad'>
								Crear <br /> Relación
							</p>
						</div>
					</Link>

					<Link style={{ textDecoration: "none" }} to='/lealtad/alertas'>
						<div className='button-index-left2-lealtad'>
							<IoNotificationsCircleSharp className='icon-button-left2-lealtad' />
							<p className='text-button-left2-lealtad'>Alertas</p>
						</div>
					</Link>
				</div>
			)}
		</div>
	);
};

export default Menu;